import { call, takeLatest } from 'redux-saga/effects';
import apiCall from '../../helpers/ApiCall';
import apiRoot from '../../consts/apiRoot';
import { SET_SEEN_BY_DEALER } from '../../redux/Conversations';

function* setSeenByDealerFlow({ payload: { conversationId, }, }) {
  const endpoint = `${apiRoot}/conversations/${conversationId}/seen_by_dealer`;
  yield call(apiCall, { method: 'GET', endpoint, });
}

export default function* SetSeenByDealer() {
  yield takeLatest(SET_SEEN_BY_DEALER, setSeenByDealerFlow);
}
